
<div class="pdf-container">
  <canvas #pdfCanvas></canvas>

  <div *ngIf="isLoading" class="spinner">
    <p-progressSpinner></p-progressSpinner>
  </div>
</div>

<div class="pdf-container">
  <div>{{ currentPage }} / {{ maxPages }}</div>
</div>

<div class="pdf-container">
  <button [disabled]="isLoading || currentPage === 1" type="button" class="btn btn-primary video-button" (click)="previousPage()">
    <i class="fas fa-arrow-left"></i>
  </button>
  <button [disabled]="isLoading || currentPage === maxPages" type="button" class="btn btn-primary video-button" (click)="nextPage()">
    <i class="fas fa-arrow-right"></i>
  </button>
</div>

<div class="pdf-open-link">
  <a href="javascript:void(0)" (click)="openFile()">
    Open document in new window&nbsp;
    <i class="fas fa-external-link-alt"></i>
  </a>
</div>

